// Generated by Claude Code
import { Minus, Plus } from 'lucide-react'
import type { MouseEvent } from 'react'

export interface StepperButtonProps {
  /** Which side of the stepper this button is: the minus or the plus. */
  direction: 'decrease' | 'increase'
  disabled?: boolean
  /** Accessible name, since the button carries only an icon. */
  ariaLabel: string
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

/** One −/+ button of a quantity stepper (part stock, minimum stock, vendor quantities). */
export function StepperButton({ direction, disabled, ariaLabel, onClick }: StepperButtonProps) {
  const Icon = direction === 'decrease' ? Minus : Plus
  return (
    <button
      type="button"
      className="btn btn-sm btn-outline-secondary ynt-stepper-btn"
      aria-label={ariaLabel}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon size={14} />
    </button>
  )
}
